import { Box } from '@mui/material';
import React from 'react';

const frameSx = {
  position: 'relative' as const,
  bgcolor: '#111',
  height: 160,
  borderTopLeftRadius: 8,
  borderTopRightRadius: 8,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
};

interface VideoZoneEmbedProps {
  index: number;
  embedUrl: string;
  dragActive: boolean;
}

/** An external (YouTube/Vimeo) embed. Click-through is disabled while something is being dragged. */
export default function VideoZoneEmbed({ index, embedUrl, dragActive }: VideoZoneEmbedProps) {
  return (
    <Box sx={frameSx}>
      <iframe
        width="100%"
        height="100%"
        src={embedUrl}
        title={`Slide ${index + 1} embedded video`}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        style={{ border: 'none', pointerEvents: dragActive ? 'none' : 'auto' }}
      />
    </Box>
  );
}
